<template>
  <layout-form>
    <select-collection />
    <input-fields />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib//Layout/Form'
import SelectCollection from './SelectCollection'
import InputFields from './InputFields'

export default {
  components: {
    LayoutForm,
    SelectCollection,
    InputFields
  }
}
</script>
